let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Ep7K")).then(() => parcelRequire('9GP0d'));